import { BriefcaseBusiness, Info } from "lucide-react";
import { DISCLOSURES, IMAGES } from "@/config/site";
import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Section, SectionHeading } from "@/components/common/Section";
import { Reveal } from "@/components/common/Reveal";
import { EmptyState } from "@/components/common/EmptyState";
import { ProtoForm } from "@/components/forms/ProtoForm";
import { therapistFields } from "@/components/forms/formSchemas";
import { CollectiveEndorsement } from "@/components/common/CollectiveEndorsement";

export default function JoinTeam() {
  useSeo({
    title: "Join Our Team | Massage Therapist Careers | Legacy Spa Houston",
    description:
      "Qualified massage professionals are invited to express interest in growing with Legacy Spa in Greater Houston. Current opportunities are posted when available.",
    path: "/join-our-team",
  });

  return (
    <>
      <PageHero
        eyebrow="Join Our Team"
        titleLines={["Grow with", "Legacy Spa."]}
        lead="We welcome interest from qualified massage professionals as the company grows."
        image={IMAGES.therapistHands}
        imageAlt="A professional massage therapist at work."
      />

      <Section className="bg-legacy-charcoal">
        <div className="mb-12">
          <Reveal>
            <EmptyState
              icon={BriefcaseBusiness}
              title="No active openings posted"
              description={DISCLOSURES.therapistInterest}
            />
          </Reveal>
        </div>

        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="Express Interest"
              title="Introduce yourself."
              as="h2"
              lead="Share a little about your background and interests. We'll reach out as opportunities become available."
            />
            <div className="mt-8 flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm text-white/60">
              <Info className="mt-0.5 h-4 w-4 shrink-0 text-legacy-mint" aria-hidden="true" />
              <p>
                Please do not submit Social Security numbers, identity documents,
                banking or health information. Résumé uploads are not accepted
                through this website at this time.
              </p>
            </div>
            <CollectiveEndorsement className="mt-10" />
          </div>
          <div className="lg:col-span-8">
            <ProtoForm
              formId="therapist-interest"
              endpoint="therapist"
              smsOptIn
              testId="therapist-form"
              tone="dark"
              fields={therapistFields}
              submitLabel="Submit Interest"
              consentLabel="I consent to Legacy Spa contacting me about future opportunities."
            />
          </div>
        </div>
      </Section>
    </>
  );
}
